/* @flow */

function encode(strings: Array<string>, ...values: Array<string>): string {
  return strings.reduce((url: string, part: string, i: number): string => {
    return url + part + (values[i] ? encodeURIComponent(values[i]) : '');
  }, '');
}

export {
  encode
};
